app.directive('socialFeed', [function () {
    return {
        restrict: "EA",
        transclude: true,
        template: "<ng-transclude></ng-transclude>",
        scope: {
            socialFeed: "="
        },
        link: function (scope, elem, attrs) {
            var options;
            options = {
                length: 165,
                update_period: 30000,
                template: "/js/template.html"
            }

            if(scope.socialFeed.display_social_images == 1) {
                options.show_media = true;
            }

            if(scope.socialFeed.facebook_query) {
                options.facebook = {
                    accounts: scope.socialFeed.facebook_accts,
                    limit: scope.socialFeed.max_count,                                   //Integer: max number of posts to load
                    access_token: '679874995488832|c2eb826d3581b01cc2d9c93717bdf442'  //String: "APP_ID|APP_SECRET"
                }
            }

            if(scope.socialFeed.twitter_query) {
                options.twitter = {
                    accounts: scope.socialFeed.twitter_accts,
                    limit: scope.socialFeed.max_count,                                   //Integer: max number of posts to load
                    consumer_key: 'eUkjsnyvbyv3MUJYXXyRXuqtr',
                    //proxy: "http://codebird.kulaboard.site/",
                    consumer_secret: 'wx0SUwhEle5Wp0AuXRKO21prOSh85XRSJh26vh8vQHSykvW4xf'
                }
            }

            $('#social-feed-container' + scope.socialFeed.id).socialfeed(options);
        }
    }
}]);